import React from 'react';
import { KebabCase } from '../../../utils/StringUtil.js';
import { onExecuteKeyDown } from '../../../utils/KeyboardUtil.js';
var SidebarMenuItem = function SidebarMenuItem(_ref) {
  var _item$target_url;
  var item = _ref.item,
    isSelected = _ref.isSelected,
    navigate = _ref.navigate,
    frontEndDomain = _ref.frontEndDomain,
    onClickLink = _ref.onClickLink;
  var isFrontEndDestination = (_item$target_url = item.target_url) === null || _item$target_url === void 0 ? void 0 : _item$target_url.includes(frontEndDomain || '');
  var isFrontEnd = typeof window !== 'undefined' && window.location.href.includes(frontEndDomain || '') && isFrontEndDestination;
  var targetUrl = isFrontEnd ? null : item.target_url;
  var onClick = function onClick(e) {
    if (!isFrontEnd) return false;
    e.stopPropagation();
    e.preventDefault();
    onClickLink(item.target_url);
    if (navigate) {
      navigate(item.target_url.replace(frontEndDomain || '', ''));
    } else {
      window.location.href = item.target_url.replace(frontEndDomain || '', '');
    }
  };
  return /*#__PURE__*/React.createElement("li", {
    className: isSelected(item) ? 'selected' : ''
  }, /*#__PURE__*/React.createElement("a", {
    "aria-current": isSelected(item) ? 'page' : undefined,
    role: "link",
    "data-object-type": "sidebar-navigation",
    "data-object-action": "sidebar-".concat(KebabCase(item.title), "-select"),
    id: item.id,
    href: targetUrl || item.target_url,
    onClick: onClick,
    onKeyDown: onExecuteKeyDown(onClick),
    tabIndex: 0
  }, item.title));
};
SidebarMenuItem.displayName = "SidebarMenuItem";
SidebarMenuItem.displayName = 'SidebarMenuItem';
export { SidebarMenuItem };